<h5 *ngIf="currentYearEvents && currentYearEvents.length > 0">{{currentYear}}</h5>

<div class="price" *ngIf="currentYearEvents && currentYearEvents.length > 0 && course && course.prices.length > 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
    <span [innerHTML]="'courses.price' | translate"></span>
    <span> {{ formattedPrice$ | async }}</span>
    <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
</div>
<div class="price" *ngIf="course && course.price !== undefined && course.prices.length === 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
    <span [innerHTML]="'courses.price' | translate"></span>
    <span> {{ formattedPrice$ | async }}</span>
    <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
</div>
<div class="price" *ngIf="course.metadata && !course.metadata.showPrice && currentYearEvents && currentYearEvents.length > 0">
    <span [innerHTML]="'courses.noPrice' | translate"></span>
</div>
<table class="events" *ngIf="currentYearEvents && currentYearEvents.length > 0">
    <tr *ngFor="let event of currentYearEvents">
        <td class="dates">{{ event.beginDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }} - {{ event.endDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}</td>
        <td class="city">
            <a class="city" *ngIf="event.location && event.location.city" (click)="openOverlay(event)">{{ event.location.city }}</a>
        </td>
        <td class="button-wrapper">
            <a
                da-button
                (click)="goToEventDetail(event.externalId)"
                [themeType]="'Secondary'"
                [innerHTML]="'buttons.showDetails' | translate"
            ></a>
            <a
                da-button
                *ngIf="event.freeSeats > 0"
                (click)="addToCart(event.externalId, event.beginDateTime)"
                [themeType]="'Primary'"
                [innerHTML]="'buttons.bookNow' | translate"
            ></a>
            <label *ngIf="event.freeSeats <= 0" [innerHTML]="'events.noSeatsAvailable' | translate"></label>
        </td>
    </tr>
</table>
<h5 *ngIf="nextYearEvents && nextYearEvents.length > 0">{{nextYear}}</h5>
<div class="price" *ngIf="nextYearEvents && nextYearEvents.length > 0 && course.prices.length > 1 && course.prices[1].value && course.metadata && course.metadata.showPrice">
    <span [innerHTML]="'courses.price' | translate"></span>
    <span> {{ formattedPrice2$ | async }}</span>
    <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
</div>
<div class="price" *ngIf="nextYearEvents && nextYearEvents.length > 0 && course.prices.length <= 1 && course.price !== undefined && course.metadata && course.metadata.showPrice">
    <span [innerHTML]="'courses.price' | translate"></span>
    <span> {{ formattedPrice$ | async }}</span>
    <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
</div>
<div class="price" *ngIf="( course.metadata && !course.metadata.showPrice) && nextYearEvents && nextYearEvents.length > 0">
    <span [innerHTML]="'courses.noPrice' | translate"></span>
</div>
<table class="events" *ngIf="nextYearEvents && nextYearEvents.length > 0">
    <tr *ngFor="let event of nextYearEvents">
        <td class="dates">{{ event.beginDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }} - {{ event.endDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}</td>
        <td class="city">
            <a class="city" *ngIf="event.location && event.location.city" (click)="openOverlay(event)">{{ event.location.city }}</a>
        </td>
        <td class="button-wrapper">
            <a
                da-button
                (click)="goToEventDetail(event.externalId)"
                [themeType]="'Secondary'"
                [innerHTML]="'buttons.showDetails' | translate"
            ></a>
            <a
                da-button
                *ngIf="event.freeSeats > 0"
                (click)="addToCart(event.externalId, event.beginDateTime)"
                [themeType]="'Primary'"
                [innerHTML]="'buttons.bookNow' | translate"
            ></a>
            <label *ngIf="event.freeSeats <= 0" [innerHTML]="'events.noSeatsAvailable' | translate"></label>
        </td>
    </tr>
</table>
<div *ngIf="events && events.length <= 0" class="no-dates-found" [innerHTML]="'courses.noDatesFound' | translate"></div>
<p class="prebooking noEvents" *ngIf="course && course.metadata && course.metadata.waitingListEnrolable && events && events.length <= 0">
    <span [innerHTML]="'events.prebookingTextNoEvents' | translate"></span>
    <span class="button-wrapper">
        <a da-button (click)="addToWishlist()" [themeType]="'Secondary'" [innerHTML]="'buttons.prebooking' | translate"></a>
    </span>
</p>
<p class="prebooking" *ngIf="course && course.metadata && course.metadata.waitingListEnrolable && events && events.length > 0">
    <span *ngIf="!hasFreeSeats" [innerHTML]="'events.prebookingnoFreeSeats' | translate"></span>
    <span *ngIf="hasFreeSeats" [innerHTML]="'events.prebookingText' | translate"></span>
    <span class="button-wrapper">
        <a da-button (click)="addToWishlist()" [themeType]="'Secondary'" [innerHTML]="'buttons.prebooking' | translate"></a>
    </span>
</p>

<div *ngIf="course.hasRequiredQualifications && !isCourseDetails" class="required-qualifications-text">
    <span [innerHTML]="requiredQualificationsText[0]"></span>
    <a *ngIf="'courses.requiredQualifications.requiredQualificationsLink' | translate" (click)="openRequiredQualificationsModal()">
        <span [innerHTML]="'courses.requiredQualifications.requiredQualificationsLink' | translate"></span>
        <i></i>
    </a> 
    <span [innerHTML]="requiredQualificationsText[1]"></span>
</div>

<div class="notification" *ngIf="showCartUpdate$ | async as showCartUpdate">
    <div class="modal">
        <div class="location-popup" [ngClass]="showCartUpdate ? 'fade' : ''">
            <div class="title">
                <span class="checked"></span>
                <span [innerHTML]="'courses.update' | translate"></span>
            </div>
            <div class="inner-wrapper">
                <div class="details">
                    <span>{{ courseTitle }}</span>
                    <span *ngIf="yearOfEvent === 'currentYear' && course.prices.length > 1">
                        {{ formattedPrice$ | async }}
                        <!-- <span [innerHTML]="'booking.bookingParticipants.symbol' | translate"></span> -->
                    </span>
                    <span *ngIf="yearOfEvent === 'nextYear' && course.prices.length > 1">
                        {{ formattedPrice2$ | async }}
                        <!-- <span [innerHTML]="'booking.bookingParticipants.symbol' | translate"></span> -->
                    </span>
                    <span *ngIf="course.prices.length <= 1">
                        {{ formattedPrice$ | async }}                        
                        <!-- <span [innerHTML]="'booking.bookingParticipants.symbol' | translate"></span> -->
                    </span>
                </div>
                <div class="wrapper" *ngIf="course.url || (course.events && course.events.length === 0)">
                    <div class="wrapper" *ngIf="!course.url && course.isProduct" [innerHTML]="'courses.online' | translate"></div>
                </div>

                <div class="wrapper" *ngIf="!course.url && !course.isProduct">
                    <div
                        class="wrapper"
                        *ngIf="!course.url && !(course.events && course.events.length === 0)"
                    >
                        <span *ngIf="course.productType === 'SEM' || course.productType === 'WRK'" [innerHTML]="'courses.presence' | translate"></span>
                        <span *ngIf="course.productType === 'WBN'" [innerHTML]="'courses.virtual' | translate"></span>
                    </div>
                </div>
                <a (click)="goToCart()" class="button secondary" [innerHTML]="'courses.showCart' | translate"></a>
            </div>
        </div>
    </div>
</div>

<ng-template #warning>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="warn"></ng-container>
    </div>
</ng-template>
<ng-template #warn>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'addToShopingCart.courseAlreadyInCartTitle' | translate"></h3>
                <p [innerHTML]="'addToShopingCart.courseAlreadyInCartText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a class="button primary" da-link (click)="goToCart()" [innerHTML]="'courses.showCart' | translate"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #overlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="location"></ng-container>
    </div>
</ng-template>
<ng-template #location>
    <div class="location-popup" *ngIf="location$ | async as event">
        <div class="title">
            <span [innerHTML]="'common.location' | translate"></span>
        </div>
        <div class="details">
            <span><strong [innerHTML]="'common.address' | translate"></strong></span>
            <span>{{ event.location.name }}</span>
            <span>{{ event.location.street }}</span>
            <span>{{ event.location.city }} {{ event.location.zip }} </span>
            <span>{{ event.location.regionKey }}</span>
            <span>{{ countryName }} ({{ event.location.countryKey }})</span>
            <a
                *ngIf="event.location.isMapAvailable"
                target="_blank"
                [href]="envApi + 'api/v1/course/getlocationmap/' + event.location.locationSign"
                ><span [innerHTML]="'common.downloadRoute' | translate"></span
            ></a>
            <div><a class="button primary" [innerHTML]="'common.close' | translate" (click)="closeModal()"></a></div>
        </div>
    </div>
</ng-template>
<div class="notification" *ngIf="showCartUpdatePrebooking$ | async as showCartUpdatePrebooking">
    <div class="modal">
        <div class="location-popup" [ngClass]="showCartUpdatePrebooking ? 'fade' : ''">
            <div class="title">
                <span class="checked"></span>
                <span [innerHTML]="'courses.update' | translate"></span>
            </div>
            <div class="inner-wrapper">
                <div class="details">
                    <span>{{ courseTitle }}</span>

                    <div class="price">
                        <span [innerHTML]="'buttons.prebooking' | translate"></span>
                    </div>
                </div>
                <div class="wrapper">
                    <div class="wrapper" [innerHTML]="'courses.prebooking' | translate"></div>
                </div>

                <a (click)="goToCart()" class="button secondary" [innerHTML]="'courses.showCart' | translate"></a>
            </div>
        </div>
    </div>
</div>

<ng-template #warningPrebooking>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="warnPrebooking"></ng-container>
    </div>
</ng-template>
<ng-template #warnPrebooking>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'addToShopingCart.courseAlreadyInWishlistTitle' | translate"></h3>
                <p [innerHTML]="'addToShopingCart.courseAlreadyInWishlistText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button primary" da-link (click)="goToCart()" [innerHTML]="'courses.showCart' | translate"></a>
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #requiredPopup>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="requirementsModal"></ng-container>
    </div>
</ng-template>
<ng-template #requirementsModal>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'booking.preRequirements.title' | translate"></h3>
                <p [innerHTML]="'booking.preRequirements.text' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a
                            class="button primary"
                            da-link
                            (click)="goToCourseDetails()"
                            [innerHTML]="'booking.preRequirements.showDetails' | translate"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #requiredQualificationsModal>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'courses.requiredQualifications.modal.title' | translate"></h3>
                <p [innerHTML]="'courses.requiredQualifications.modal.intro' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="goToContact()" [innerHTML]="'courses.requiredQualifications.modal.contactButton' | translate"></a>
                        <a
                            class="button primary"
                            da-link
                            (click)="goToCourseDetails('prerequisites')"
                            [innerHTML]="'courses.requiredQualifications.modal.detailButton' | translate"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #notTheSameCurrencyPopup>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="notTheSameCurrencyModal"></ng-container>
    </div>
</ng-template>
<ng-template #notTheSameCurrencyModal>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'booking.currencyWarningTitle' | translate"></h3>
                <p [innerHTML]="'booking.currencyWarningText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a
                            class="button primary"
                            da-link
                            (click)="goToCart()"
                            [innerHTML]="'courses.showCart' | translate"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #requiredPopup>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="requirementsModal"></ng-container>
    </div>
</ng-template>
<ng-template #requirementsModal>
    <div class="modal prerequirements">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'booking.preRequirements.title' | translate"></h3>
                <p [innerHTML]="'booking.preRequirements.text' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a
                            class="button primary"
                            da-link
                            (click)="goToCourseDetails()"
                            [innerHTML]="'booking.preRequirements.showDetails' | translate"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
